import { Component, EventEmitter, Output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-configuracao-validada-modal',
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './configuracao-validada-modal.component.html',
  styleUrl: './configuracao-validada-modal.component.css'
})
export class ConfiguracaoValidadaModalComponent {
  @Output() enviarDados: EventEmitter<void> = new EventEmitter<void>();

  public confirmar(): void {
    this.enviarDados.emit();
  }
}
